import React, { useContext } from 'react'
import Context from '../../context'
import {
  FieldGroup, FieldRow
} from '../../layout/mixins'
import Field from '../Field'


const PrivateInvoiceAddress = () => {
  const { setField, getValue } = useContext(Context)

  return (
    <>
      <FieldRow>
        <Field
          name="invoice_company"
          placeholder="Namn"
          onChange={setField('invoice_company')}
          value={getValue('invoice_company')}
          required
          half
        />
        <Field
          name="invoice_address_line_1"
          placeholder="Adress"
          onChange={setField('invoice_address_line_1')}
          value={getValue('invoice_address_line_1')}
          required
          half
        />

      </FieldRow>
      <FieldRow>
        <Field
          name="invoice_postal_code"
          placeholder="Postnummer"
          onChange={setField('invoice_postal_code')}
          value={getValue('invoice_postal_code')}
          required
          half
        />
        <Field
          name="invoice_city"
          placeholder="Ort"
          onChange={setField('invoice_city')}
          value={getValue('invoice_city')}
          required
          half
        />
      </FieldRow>
    </>
  )
}

export default PrivateInvoiceAddress